import React, { useEffect, useState } from "react";
import { useSelector, useDispatch } from "react-redux";
import {
  CSidebar,
  CSidebarBrand,
  CSidebarNav,
  // CSidebarToggler,
  CNavGroup,
  CNavItem,
} from "@coreui/react-pro";
import CIcon from "@coreui/icons-react";
// import { Icon } from "@iconify/react";

import { AppSidebarNav } from "./AppSidebarNav";

import SimpleBar from "simplebar-react";
import "simplebar/dist/simplebar.min.css";
// import axios from "axios";
// sidebar nav config
import Swal from "sweetalert";
import { useHistory } from "react-router";
import { logout } from "src/configs/redux/action/userAction";
import kalasanLogo from "src/assets/brand/kalasan-logo.png";
import { cilAccountLogout } from "@coreui/icons";

const AppSidebar = () => {
  const dispatch = useDispatch();
  const history = useHistory();
  const menu = useSelector((state) => state.user.profile.permission);
  const role = useSelector((state) => state.user.profile.role);
  const unfoldable = useSelector((state) => state.interface.sidebarUnfoldable);
  const sidebarShow = useSelector((state) => state.interface.sidebarShow);
  const [dataMenu, setDataMenu] = useState([]);

  const functionMenu = () => {
    let data = [
      {
        component: CNavItem,
        name: "Dashboard",
        icon: <i className="fas fa-tachometer-alt nav-icon" />,
        to: "/dashboard",
      },
    ];

    let menuList = [...(menu || [])];
    const teknisiIndex = menuList.findIndex(
      (m) => m.name?.toLowerCase() === "teknisi"
    );
    const historiIndex = menuList.findIndex(
      (m) => m.name?.toLowerCase() === "histori"
    );

    if (teknisiIndex === -1 && (role === "SUPERUSER" || role === "TEKNISI")) {
      const teknisiMenu = {
        name: "Teknisi",
        url: "/",
        icon: "fa fa-wrench",
        isParent: true,
        child: [
          {
            name: "Teknisi Maintanance",
            url: "/teknisi/maintenance-request",
            permission: ["c", "r", "u", "d", "p", "a"],
          },
          {
            name: "Maintanance Request",
            url: "/maintenance-request",
            permission: ["c", "r", "u", "d"],
          },
        ],
      };

      if (historiIndex !== -1) {
        menuList.splice(historiIndex, 0, teknisiMenu);
      } else {
        menuList.push(teknisiMenu);
      }
    } else if (teknisiIndex !== -1) {
      const currentChildren = menuList[teknisiIndex].child || [];
      const hasTeknisiMaint = currentChildren.some(
        (c) => c.url === "/teknisi/maintenance-request"
      );

      const existingChild = currentChildren.find(
        (c) =>
          c.url === "/maintenance-request" ||
          c.url === "/teknisi/maintenance-request"
      );
      const basePermission = existingChild?.permission || [
        "c",
        "r",
        "u",
        "d",
        "p",
        "a",
      ];

      let newChildren = [];
      if (
        role === "SUPERUSER" ||
        role === "TEKNISI" ||
        basePermission.includes("a") ||
        hasTeknisiMaint
      ) {
        newChildren.push({
          name: "Teknisi Maintanance",
          url: "/teknisi/maintenance-request",
          permission: basePermission,
        });
      }

      newChildren.push({
        name: "Maintanance Request",
        url: "/maintenance-request",
        permission: ["c", "r", "u", "d"],
      });

      menuList[teknisiIndex] = {
        ...menuList[teknisiIndex],
        child: newChildren,
      };

      if (historiIndex !== -1 && teknisiIndex > historiIndex) {
        const [teknisiMenu] = menuList.splice(teknisiIndex, 1);
        const targetIndex = menuList.findIndex(
          (m) => m.name?.toLowerCase() === "histori"
        );
        menuList.splice(targetIndex, 0, teknisiMenu);
      }
    }

    menuList.map((value) => {
      if (value.isParent && value.child) {
        let dataParent = "";
        if (value.child.length > 0) {
          dataParent = {
            component: CNavGroup,
            name: `${value.name}`,
            icon: <i className={`${value.icon} nav-icon`} />,
            items: [],
          };
          let child = value.child;
          let masterGroup = {
            component: CNavItem,
            name: "Master",
            to: "",
          };
          
          let masterCount = 0;

          child.forEach((valueChild) => {
            if (valueChild.name.toLowerCase() !== "daftar wajah" && valueChild.name.toLowerCase() !== "absensi" && valueChild.name.toLowerCase() !== "lihat absensi") {
              let childName = valueChild.name;
              
              if (valueChild.name.toLowerCase() === "cuti karyawan") {
                childName = "Master Cuti";
              }

              let dataChild = {
                component: CNavItem,
                name: `${childName}`,
                to: `${valueChild.url}`,
              };

              if (
                value.name === "Personalia" &&
                (valueChild.name.toLowerCase() === "master shift" ||
                  valueChild.name.toLowerCase() === "master cuti" ||
                  valueChild.name.toLowerCase() === "cuti karyawan" ||
                  valueChild.name.toLowerCase() === "master salary")
              ) {
                if (masterCount === 0) {
                  masterGroup.to = valueChild.url;
                }
                masterCount++;
              } else {
                dataParent.items.push(dataChild);
              }
            }
          });

          if (masterCount > 0) {
            dataParent.items.push(masterGroup);
          }
          // data.push(dataParent);
        } else {
          dataParent = {
            component: CNavItem,
            name: `${value.name}`,
            icon: <i className={`${value.icon} nav-icon`} />,
            to: `${value.url}`,
          };
        }
        data.push(dataParent);
      }
    });
    const newData = data.filter((m) => m.name !== "Tablet");
    setDataMenu(newData);
  };

  useEffect(() => {
    functionMenu();
  }, [menu, role]);

  const onLogOut = (e) => {
    Swal("Yakin keluar aplikasi?", {
      dangerMode: true,
      cancel: true,
      buttons: true,
      icon: "info",
    }).then((result) => {
      if (result) {
        dispatch(logout(history));
      }
    });
  };

  return (
    <CSidebar
      position="fixed"
      unfoldable={unfoldable}
      visible={sidebarShow}
      onVisibleChange={(visible) => {
        dispatch({ type: "set", sidebarShow: visible });
      }}
    >
      <CSidebarBrand className="d-none d-md-flex" to="/">
        <img
          className="sidebar-brand-full"
          src={kalasanLogo}
          height={35}
          alt="kalasanLogo-logo"
        />
      </CSidebarBrand>
      <CSidebarNav>
        <SimpleBar>{dataMenu && <AppSidebarNav items={dataMenu} />}</SimpleBar>
      </CSidebarNav>
      <div className="logout mb-5" onClick={() => onLogOut()}>
        <CIcon icon={cilAccountLogout} customClassName="nav-icon-logout" /> Log
        Out
      </div>
    </CSidebar>
  );
};

export default React.memo(AppSidebar);
